// Ring 0 — locked platformer-feel constants. NO Phaser imports.
//
// ALL UNITS: px, ms, px/s, px/s². NO bare frame counts.
//
// Notes:
// - `MAX_DT_MS = 50` is the tab-blur safety net (PITFALL #13). Combine
//   with `pauseOnBlur: true` in the Phaser game config; the cap protects
//   against any RAF-backlog spike that pauseOnBlur misses.
// - `JUMP_VELOCITY` and `MOVE_SPEED` are RECOMMENDED-START values per
//   D-08; they will be calibrated against real floor geometry in Wave 3
//   (RESEARCH Open-Q #2). Do NOT inline-tune in entity files.
// - Asymmetric fall gravity (CLIMB-02) and fast-fall (D-09) require
//   per-body gravity, not `world.gravity`. The Phaser game config zeros
//   `world.gravity.y` for that reason.
//
// LOCKED VALUES per D-08 / D-09. Changing any of these requires a new
// decision record in the phase CONTEXT.md.

export const TUNABLES = {
  // Gravity (px/s²) — base ascent gravity; multipliers below scale it.
  GRAVITY:                  900,
  FALL_GRAVITY_MULT:        1.6,    // D-08
  FAST_FALL_GRAVITY_MULT:   2.4,    // D-09
  MAX_FALL_SPEED:           600,    // px/s — terminal velocity safety cap

  // Jump (px/s) — vertical velocities are NEGATIVE (Phaser y axis).
  JUMP_VELOCITY:           -360,    // RECOMMENDED START (calibrate Wave 3)
  MIN_JUMP_VELOCITY:       -120,    // variable-jump cut threshold
  COYOTE_MS:                110,    // D-08
  JUMP_BUFFER_MS:           130,    // D-08

  // Horizontal (px/s, px/s²)
  MOVE_SPEED:               110,    // RECOMMENDED START (calibrate Wave 3)
  RUN_ACCEL:                550,
  AIR_CONTROL_RATIO:        0.85,   // D-08

  // Frame-time safety (ms) — PITFALL #13 dt cap.
  MAX_DT_MS:                50,

  // One-way platform drop-through (CLIMB-03, RESEARCH Pattern 7).
  // The processCallback in RunScene reads `dropThroughUntilMs` on the
  // Player; this is the size of that grace window in ms. The kick is a
  // small downward velocity nudge so the player visibly drops rather
  // than waiting for gravity to grow.
  DROP_THROUGH_MS:          200,
  DROP_THROUGH_KICK:         80,
} as const;
